/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Image } from 'react-bootstrap';
import * as S from './styles';

export interface IRankingWidgetProps {
  rankings: {
    icon?: string | any;
    title: string;
    description?: string;
    descriptionIcon?: string | any;
    value: string;
    valueLink?: string;
    valueIcon?: string;
  }[];
}

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const RankingWidget = ({ rankings }: IRankingWidgetProps) => {
  const _getIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === 'string') {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={60}
            height={60}
            className="icon icon-xs text-gray-500 me-2"
          />
        );
      } else {
        const HeroIcon = require('@heroicons/react/solid');
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon
              key={`hero-icon`}
              src={Icon}
              className="icon icon-xs text-gray-500 me-2"
            />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(
        <Icon key={`hero-icon-2`} className="icon icon-xs text-gray-500 me-2" />
      );
    }
    return _icon;
  };

  const _getDescriptionIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === 'string') {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={60}
            height={60}
            className="icon icon-xs text-gray-500 ms-2"
          />
        );
      } else {
        const HeroIcon = require('@heroicons/react/solid');
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon
              key={`hero-icon`}
              src={Icon}
              className="icon icon-xs text-gray-500 ms-2"
            />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(
        <Icon key={`hero-icon-2`} className="icon icon-xs text-gray-500 ms-2" />
      );
    }
    return _icon;
  };

  const _renderRankingTitleIf = (ranking: any) => {
    if (ranking?.title) {
      return (
        <div className="d-flex align-items-center h6 mb-0">
          {_getIcon(ranking?.icon)}
          {ranking?.title}
        </div>
      );
    }
  };

  const _renderRankingDescriptionIf = (ranking: any) => {
    if (ranking?.description) {
      return (
        <div>
          <Card.Text className="small card-stats d-flex align-items-center">
            {ranking.description}
            {_getDescriptionIcon(ranking?.descriptionIcon)}
          </Card.Text>
        </div>
      );
    }
  };

  const _renderRankingValueIf = (ranking: any) => {
    if (ranking?.value) {
      return (
        <div>
          <Card.Link
            href={ranking?.valueLink ?? '#'}
            className="d-flex align-items-center fw-bold"
          >
            {ranking?.value}
            {_getDescriptionIcon(ranking.valueIcon)}
          </Card.Link>
        </div>
      );
    }
  };

  const _renderRankings = () => {
    let _comp: any = [];
    rankings?.forEach((ranking, index) => {
      _comp.push(
        <div
          key={`ranking-widget-item-${index}`}
          className="d-flex align-items-center justify-content-between border-bottom pb-3"
          style={S.RankingContainerStyle}
        >
          <div>
            {_renderRankingTitleIf(ranking)}
            {_renderRankingDescriptionIf(ranking)}
          </div>
          {_renderRankingValueIf(ranking)}
        </div>
      );
    });
    return _comp;
  };
  if (rankings?.length) {
    return (
      <>
        <Card border="0" className="shadow">
          <Card.Body>{_renderRankings()}</Card.Body>
        </Card>
      </>
    );
  }
  return null;
};

RankingWidget.defaultProps = {};
